
import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription, take } from 'rxjs';
import { ServiceUtil } from 'src/shared/utilities/service.util';

@Component({
	templateUrl: 'logout.component.html'
})
export class LogoutComponent implements OnInit {
	logoutSubscription: Subscription | undefined;

	constructor(private _oidcSecurityService: OidcSecurityService,
		        private _serviceUtil: ServiceUtil) {
	}

	ngOnInit(): void {
		this.logoffAndRevokeTokens();
	}

	logoffAndRevokeTokens() {
		this.logoutSubscription = this._oidcSecurityService.logoffAndRevokeTokens().pipe(take(1))
			.subscribe((result) => {
				if (!result) {
					sessionStorage.clear();
					window.location.href = this._serviceUtil.webApiServer + '/Account/Logout';
				}
			});
	}
}
